/* AG Admin Shipping, operator UI for the Shipping Calculator.
 *
 * Tabs:
 *   - Test calculator (synthetic quote tester at top, runs against live calc)
 *   - Service tiers (Standard / Express / Next Day…)
 *   - Parcel rates (weight×zone matrix)
 *   - Pallet rates (weight×zone matrix)
 *   - Zones (postcode prefix → zone)
 *   - Free shipping (rules)
 *   - SKU overrides (per-SKU flat fees / extras / pallet-only flags)
 *   - Config (general)
 *   - Logs (last 30 quote requests)
 *
 * Talks to ag-shipping-script /exec via window.AG_ADMIN.api (provided
 * by AG-Admin-Shell). Backend lives at github.com/AssassinGoods/ag-shipping-script.
 */
(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function fmtMoney(n) { var x = parseFloat(n) || 0; return '£' + x.toFixed(2); }
  function fmtDate(s) { return String(s || '').slice(0, 10); }

  var TABS = [
    { id: 'test',       label: 'Test calculator' },
    { id: 'carriers',   label: 'Carriers' },
    { id: 'buckets',    label: 'Speed buckets' },
    { id: 'meta',       label: 'Carrier × bucket' },
    { id: 'rates',      label: 'Parcel rates' },
    { id: 'surcharges', label: 'Surcharges' },
    { id: 'pallets',    label: 'Pallet rates' },
    { id: 'zones',      label: 'Zones' },
    { id: 'free',       label: 'Free shipping' },
    { id: 'overrides',  label: 'SKU overrides' },
    { id: 'closed',     label: 'Closed days' },
    { id: 'products',   label: 'Product carriers' },
    { id: 'config',     label: 'Config' },
    { id: 'logs',       label: 'Logs' },
    { id: 'tools',      label: 'Tools' },
    { id: 'info',       label: 'How it works' }
  ];

  var state = {
    tab: 'test',
    payload: null,
    testItems: [{ sku: '', quantity: 1, grams: 1000, price_pence: 5000 }],
    testPostcode: 'CA11 9DP',
    testCountry: 'GB',
    testRequestedShipDate: ''
  };

  /* Dirty-row tracker. Keyed by sheet name + _row so it survives tab
     switches and table-level repaints. Wired below into:
       - input/change handlers (mark dirty)
       - per-row Save + Save all (mark clean on success)
       - window.beforeunload (block navigation if dirty)
     A single global object is plenty, there's only ever one operator
     editing at a time. */
  var dirty = { rows: {} }; // { "<sheetKey>:<rowNum>": { ref, saveAction, headers } }
  function dirtyKey(sheetKey, rowNum) { return sheetKey + ':' + rowNum; }
  function markDirty(sheetKey, row, headers, saveAction) {
    if (!row._row) return; // un-saved blank row not tracked
    dirty.rows[dirtyKey(sheetKey, row._row)] = { ref: row, saveAction: saveAction, headers: headers, sheetKey: sheetKey };
    refreshDirtyUi();
  }
  function markClean(sheetKey, row) {
    delete dirty.rows[dirtyKey(sheetKey, row._row || 0)];
    refreshDirtyUi();
  }
  function dirtyCount() { return Object.keys(dirty.rows).length; }
  function refreshDirtyUi() {
    var btn = document.getElementById('ship-save-all');
    var cnt = document.getElementById('ship-dirty-count');
    if (!btn || !cnt) return;
    var n = dirtyCount();
    btn.style.display = n > 0 ? '' : 'none';
    cnt.textContent = String(n);
  }
  window.addEventListener('beforeunload', function(e) {
    if (dirtyCount() === 0) return;
    e.preventDefault();
    e.returnValue = '';
    return '';
  });

  window.AG_ADMIN.onReady(function () {
    boot();
  });

  function boot() {
    renderTabs();
    refresh();
  }

  function renderTabs() {
    var tabsEl = $('ship-tabs');
    if (!tabsEl) return;
    tabsEl.innerHTML = TABS.map(function(t) {
      return '<button class="ag-tab' + (state.tab === t.id ? ' active' : '') + '" data-tab="' + t.id + '">' + esc(t.label) + '</button>';
    }).join('');
    tabsEl.querySelectorAll('button[data-tab]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (dirtyCount() > 0 && !confirm('You have ' + dirtyCount() + ' unsaved change(s). Switch tabs anyway? Edits will be lost.')) return;
        /* Discard unsaved changes on tab switch, they live in the
           `rows` arrays of the previous tab's render, which get blown
           away by the next bootstrap load. */
        dirty.rows = {};
        refreshDirtyUi();
        state.tab = btn.dataset.tab;
        renderTabs();
        renderTab();
      });
    });
  }

  function refresh() {
    AG_ADMIN.api('ui_bootstrap', {}).then(function(p) {
      state.payload = p;
      renderTab();
    }).catch(function(e) {
      $('ship-content').innerHTML = '<div class="ag-empty">Failed to load: ' + esc(e.message || e) + '</div>';
    });
  }

  function renderTab() {
    if (!state.payload) return;
    var root = $('ship-content');
    switch (state.tab) {
      case 'test':      return renderTest(root);
      case 'carriers':  return renderTable(root, 'carriers',       'ui_save_carrier',       'ui_delete_carrier',       'Your couriers. Add one row per carrier you ship with (DPD, DX, Royal Mail, etc.). Tag products in Shopify with carrier:<id> to route them through a specific carrier. is_pallet_carrier marks the one you use for pallet shipments.');
      case 'buckets':   return renderTable(root, 'speed_buckets',  'ui_save_speed_bucket',  'ui_delete_speed_bucket',  'Customer-facing delivery options at checkout: Standard, Express, Next Day Before 12, Saturday, etc. The calc returns one rate per bucket that every carrier in the cart can fulfil.');
      case 'meta':      return renderTable(root, 'carrier_bucket_meta', 'ui_save_bucket_meta', 'ui_delete_bucket_meta', 'Which carrier offers which speed. One row per (carrier × speed bucket): set min/max delivery days, the daily cutoff hour, weekend-dispatch flag, day-of-week gate (e.g. FRI for Saturday-only services), and universal-fallback flag.', { filterByCarrier: 'metaCarrier' });
      case 'rates':     return renderTable(root, 'rates',          'ui_save_rate',          'ui_delete_rate',          'Parcel rates per (carrier, speed bucket, zone). Each row sets the first-parcel rate, every-extra-parcel rate, fuel %, other per-parcel charges, and whether to add 20% VAT. Max kg per SKU is optional. When set, rows are skipped if any cart item exceeds that weight.', { filterByCarrier: 'ratesCarrier' });
      case 'surcharges':return renderTable(root, 'surcharges',     'ui_save_surcharge',     'ui_delete_surcharge',     'Add-on charges layered on top of parcel rates when conditions match. Examples: Highlands surcharge by zone, oversize fee triggered by a product tag, fuel surcharge on every order, residential delivery fee.', { filterByCarrier: 'surchargeCarrier' });
      case 'pallets':   return renderTable(root, 'pallets',        'ui_save_pallet',        'ui_delete_pallet',        'Pallet rates by postcode prefix. Longest matching prefix wins (CA10 beats CA). Blank prefix = catch-all default.');
      case 'zones':     return renderTable(root, 'zones',          'ui_save_zone',          'ui_delete_zone',          'Map postcode prefixes to broad shipping zones (Mainland, Highlands, NI, IoM, CI). Used everywhere except pallets.');
      case 'free':      return renderTable(root, 'free_shipping',  'ui_save_free_shipping', 'ui_delete_free_shipping', 'One row per (zone × carrier × bucket × threshold) combination, operator picks exactly which service goes free. Leave carrier or speed_bucket BLANK to mean "any". force_free=TRUE means no minimum (always free for that combo). Important: pallet rates never go free unless you explicitly add a row with the pallet carrier. So a "free Standard at £50" rule won\'t accidentally make a £55 pallet order free.');
      case 'overrides': return renderTable(root, 'sku_overrides',  'ui_save_sku_override',  'ui_delete_sku_override',  'Per-SKU overrides: charge a flat shipping fee for a specific SKU regardless of weight, add a fixed extra-per-unit surcharge, or force this SKU to ship by pallet.');
      case 'closed':    return renderTable(root, 'closed_days',    'ui_save_closed_day',    'ui_delete_closed_day',    'Days we do NOT dispatch, UK bank holidays + warehouse closures. Delivery-window dates shown at checkout skip past these. For a single day, fill only Start; for a range (e.g. Christmas shutdown), fill both Start and End (inclusive). UK bank holidays auto-refresh monthly from gov.uk; add warehouse-specific closures as needed.');
      case 'products':  return renderProductCarriers(root);
      case 'config':    return renderConfig(root);
      case 'logs':      return renderLogs(root);
      case 'tools':     return renderTools(root);
      case 'info':      return renderInfo(root);
    }
  }

  /* ─── Info, colleague-facing onboarding/glossary ─────────── */
  function renderInfo(root) {
    root.innerHTML = `
      <h2 class="ag-h2">How AG Shipping works</h2>
      <p class="ag-muted" style="font-size:13px;max-width:760px;margin:0 0 18px;">
        Reference for new staff. This page is what tells Shopify what to charge customers for delivery.
        Read top-to-bottom or jump to a section.
      </p>

      <div class="ag-grid" style="grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:8px;margin-bottom:24px;">
        <a class="ag-card" href="#shipinfo-what">What this is</a>
        <a class="ag-card" href="#shipinfo-flow">How a quote happens</a>
        <a class="ag-card" href="#shipinfo-tabs">What each tab does</a>
        <a class="ag-card" href="#shipinfo-tagging">Tagging products to carriers</a>
        <a class="ag-card" href="#shipinfo-glossary">Glossary</a>
        <a class="ag-card" href="#shipinfo-edits">Common edits</a>
        <a class="ag-card" href="#shipinfo-trouble">Troubleshooting</a>
        <a class="ag-card" href="#shipinfo-cutover">Going live (cutover)</a>
      </div>

      <section id="shipinfo-what" style="margin-bottom:28px;">
        <h3 style="font-size:16px;margin:0 0 8px;">What this is</h3>
        <p>AG Shipping is a custom Shopify <em>Carrier Service</em> built in Google Apps Script. It replaces the third-party "Postcode Shipping by Pigeon" app we used to rely on.</p>
        <p><strong>What it does:</strong> when a customer reaches the cart/checkout, Shopify POSTs the cart contents + destination to our /exec URL. We look at every line item, work out which carrier should handle each, compute a price per offered service (Standard, Express, Next Day Before 12, Saturday, etc.), and return the rates Shopify shows to the customer.</p>
        <p><strong>Why we built it:</strong> Pigeon was too rigid, no per-variant carrier overrides, awkward postcode handling, no per-bucket Saturday-only gating, and a monthly subscription. This replaces it with rules we own.</p>
        <p><strong>Where data lives:</strong> all the editable tabs above (Carriers, Speed buckets, Parcel rates, etc.) write to a Google Sheet. The /exec endpoint reads that sheet on every quote. There's no separate database.</p>
      </section>

      <section id="shipinfo-flow" style="margin-bottom:28px;">
        <h3 style="font-size:16px;margin:0 0 8px;">How a quote happens (in order)</h3>
        <ol>
          <li><strong>Country gate.</strong> If the destination isn't GB, we return no rates and Shopify falls through to whatever else is configured (or shows "no shipping").</li>
          <li><strong>Zone resolve.</strong> Postcode → zone via longest-prefix match against the Zones tab (e.g. <code>IV1</code> → highlands; <code>BT</code> → northern-ireland). Default is mainland.</li>
          <li><strong>Group cart items by carrier.</strong> Every product is either tagged <code>carrier:&lt;id&gt;</code> in Shopify (or has a variant override) or falls back to the carrier marked "is_fallback" on the Carriers tab.</li>
          <li><strong>Pallet check.</strong> If total weight ≥ <code>pallet_threshold_kg</code> (Config) or any item is marked pallet-only, we use the Pallet rates tab instead of parcel rates. Pallets are POSTCODE-LOCKED (longest prefix wins), not zone-based.</li>
          <li><strong>For each speed bucket</strong> (Standard, Express, NDB12, Saturday…), we ask: can every carrier in the cart fulfil this bucket today?
            <ul>
              <li>Check the Carrier × bucket tab for enabled + day-of-week availability (e.g. Saturday delivery only sold on Fridays).</li>
              <li>If a carrier can't fulfil this bucket, look for a "ships anything" fallback carrier.</li>
              <li>Look up the rate row in Parcel rates by (carrier × bucket × zone), pick the lightest tier that fits the cart weight.</li>
            </ul>
          </li>
          <li><strong>Per-row uplifts:</strong> fuel % + other charges + 20% VAT (if ticked).</li>
          <li><strong>Multi-parcel split:</strong> if cart weight > the row's <code>weight_max_kg</code>, we charge first parcel + N×subsequent rate.</li>
          <li><strong>Surcharges:</strong> Surcharges tab rows fire when conditions match (zone, postcode prefix, weight band, cart tag). Carrier-specific surcharges fire once per carrier; cart-wide ones (blank carrier) fire once per cart.</li>
          <li><strong>Free shipping:</strong> Free shipping tab. If a rule matches AND cart subtotal ≥ minimum, total drops to £0 and label switches to "(free)". <code>force_free</code> overrides everything else.</li>
          <li><strong>Hold dispatch until:</strong> if the customer picked a date on the cart, or you set a <em>Requested ship date</em> in the test calculator, that date becomes the dispatch day: every ETA is measured from it rather than from today. Services that only run on certain days (Saturday delivery goes out on a Friday) are resolved against the dispatch day too, so changing this date is what moves those options and their dates.</li>
        </ol>
      </section>

      <section id="shipinfo-tabs" style="margin-bottom:28px;">
        <h3 style="font-size:16px;margin:0 0 8px;">What each tab does</h3>
        <table class="ag-table" style="font-size:13px;">
          <thead><tr><th>Tab</th><th>What it controls</th></tr></thead>
          <tbody>
            <tr><td><strong>Test calculator</strong></td><td>Type a postcode + cart and see exactly what a customer would be quoted. Use this before/after any rate edit.</td></tr>
            <tr><td><strong>Carriers</strong></td><td>Your couriers (DPD, DX, etc). One must be ticked "is_fallback"that's where untagged products go.</td></tr>
            <tr><td><strong>Speed buckets</strong></td><td>Customer-facing labels: Standard, Express, NDB12, Saturday. Display order = the order they appear at checkout.</td></tr>
            <tr><td><strong>Carrier × bucket</strong></td><td>One row per (carrier × bucket): delivery-day window, cutoff hour, weekend dispatch, day-of-week gate, "ships anything" fallback flag.</td></tr>
            <tr><td><strong>Parcel rates</strong></td><td>Money. One row per (carrier × bucket × zone × tier): first-parcel rate, subsequent-parcel rate, fuel %, other charges, VAT.</td></tr>
            <tr><td><strong>Surcharges</strong></td><td>Extra fees layered on top (e.g. NI surcharge, oversize fee).</td></tr>
            <tr><td><strong>Pallet rates</strong></td><td>Postcode-prefix-locked pallet rates. Used when cart weight crosses the threshold.</td></tr>
            <tr><td><strong>Zones</strong></td><td>Postcode prefix → zone (mainland / highlands / NI / IoM / CI).</td></tr>
            <tr><td><strong>Free shipping</strong></td><td>Rules for free or forced-free shipping per zone, optional min order value.</td></tr>
            <tr><td><strong>SKU overrides</strong></td><td>Per-SKU flat shipping fee, extra-per-unit, or "force pallet" flag.</td></tr>
            <tr><td><strong>Product carriers</strong></td><td>Bulk-tag products with <code>carrier:&lt;id&gt;</code> (or per-variant overrides) without going into Shopify admin.</td></tr>
            <tr><td><strong>Config</strong></td><td>Global settings, pallet threshold, fallback rate, origin postcode.</td></tr>
            <tr><td><strong>Logs</strong></td><td>Every checkout call. Useful for "why was this customer quoted £X?"</td></tr>
            <tr><td><strong>Tools</strong></td><td>Snapshot the whole config to a sister sheet (do this before risky edits), CSV import/export, audit log of who-changed-what.</td></tr>
          </tbody>
        </table>
      </section>

      <section id="shipinfo-tagging" style="margin-bottom:28px;">
        <h3 style="font-size:16px;margin:0 0 8px;">Tagging products to carriers</h3>
        <p>Every product needs to know which carrier ships it. Two ways to set this:</p>
        <ol>
          <li><strong>Product tag</strong> (the normal path): add a Shopify product tag like <code>carrier:dpd</code> or <code>carrier:dx</code>. Sync happens hourly + on-demand from the Product carriers tab.</li>
          <li><strong>Per-variant override</strong>: for products where different variants need different carriers (e.g. kettlebells, a 6kg goes parcel, a 48kg goes pallet courier), use the Per-variant override on the Product carriers tab. The override always wins over the product tag.</li>
        </ol>
        <p>Untagged products fall back to whichever carrier has <code>is_fallback=TRUE</code> on the Carriers tab, exactly ONE carrier should be marked.</p>
      </section>

      <section id="shipinfo-glossary" style="margin-bottom:28px;">
        <h3 style="font-size:16px;margin:0 0 8px;">Glossary</h3>
        <dl style="font-size:13px;">
          <dt><strong>Carrier</strong></dt>
          <dd>A courier, DPD, DX, etc. Each has its own rate tables and surcharges.</dd>
          <dt><strong>Speed bucket</strong></dt>
          <dd>A customer-facing delivery option (Standard, Express, NDB12, Saturday). Generic, multiple carriers can fulfil the same bucket.</dd>
          <dt><strong>Zone</strong></dt>
          <dd>Coarse-grained delivery region: mainland, highlands, northern-ireland, isle-of-man, channel-islands. Drives rate-table lookup for parcels.</dd>
          <dt><strong>Tier</strong></dt>
          <dd>A weight-band row within a (carrier × bucket × zone), e.g. "0-5kg @ £6", "5-15kg @ £9". Lightest tier that fits the cart wins.</dd>
          <dt><strong>Fallback carrier</strong></dt>
          <dd>The carrier products fall to when no <code>carrier:</code> tag is set. Marked is_fallback on Carriers tab.</dd>
          <dt><strong>"Ships anything" carrier</strong></dt>
          <dd>A carrier marked on Carrier × bucket meta that can fulfil ANY bucket, used when the product's primary carrier doesn't offer that bucket. Typically DX is your "ships anything" because they handle most weights.</dd>
          <dt><strong>Hold dispatch until</strong></dt>
          <dd>A customer-chosen date (cart attribute) telling the dispatch team "don't ship before X". Affects delivery-window dates shown at checkout.</dd>
          <dt><strong>Run_Log</strong></dt>
          <dd>One row per Shopify checkout call. Includes quoted price, resolved zone, rule path. Trimmed to 30 days.</dd>
          <dt><strong>Carrier Service</strong></dt>
          <dd>The Shopify API that lets a third-party (us) compute live shipping rates at checkout. Has a 10-second response budget.</dd>
        </dl>
      </section>

      <section id="shipinfo-edits" style="margin-bottom:28px;">
        <h3 style="font-size:16px;margin:0 0 8px;">Common edits</h3>
        <h4 style="font-size:14px;margin:14px 0 4px;">Update a rate</h4>
        <ol>
          <li>Open Tools → click <em>Snapshot now</em> (so you can roll back).</li>
          <li>Go to Parcel rates, filter by carrier.</li>
          <li>Edit the row. Save.</li>
          <li>Test calculator → run a postcode + cart that exercises the changed row.</li>
        </ol>

        <h4 style="font-size:14px;margin:14px 0 4px;">Add a new carrier</h4>
        <ol>
          <li>Carriers tab → add row (carrier_id e.g. <code>royal-mail</code>, label, enabled).</li>
          <li>Carrier × bucket. Add a row per speed bucket they offer (delivery days, cutoff, weekend flag).</li>
          <li>Parcel rates. Add a row per (bucket × zone) with money.</li>
          <li>Tag products with <code>carrier:royal-mail</code> in Shopify, or use Product carriers to bulk-tag.</li>
        </ol>

        <h4 style="font-size:14px;margin:14px 0 4px;">Add a postcode surcharge (e.g. £20 to a specific island)</h4>
        <p>Surcharges tab → set <code>applies_to_prefix</code> to the postcode prefix (e.g. <code>HS</code> for Outer Hebrides), <code>per_order_gbp</code> = 20, leave carrier blank to apply across all carriers.</p>

        <h4 style="font-size:14px;margin:14px 0 4px;">Bulk-import a whole rate table from a spreadsheet</h4>
        <ol>
          <li>Tools → Export → pick the table to grab a template CSV with the right headers.</li>
          <li>Edit in Excel / Numbers.</li>
          <li>Tools → Import → pick the same table, choose "Replace existing rows", attach your CSV.</li>
        </ol>

        <h4 style="font-size:14px;margin:14px 0 4px;">Disable a carrier temporarily (e.g. courier strike)</h4>
        <p>Carriers tab → untick <code>enabled</code> on that row. Affected products will route to the fallback carrier automatically.</p>
      </section>

      <section id="shipinfo-trouble" style="margin-bottom:28px;">
        <h3 style="font-size:16px;margin:0 0 8px;">Troubleshooting</h3>
        <dl style="font-size:13px;">
          <dt><strong>Customer says they were quoted "AG Shipping (estimate) £9.95"</strong></dt>
          <dd>That's the configured fallback. The calc hit an error or a gap. Open Logs tab, filter the postcode, look at <code>rule_path</code>it tells you why (e.g. <code>no-rate:carrier-disabled-or-missing:foo</code>). Usually a missing rate row for that zone, or a typo in a carrier_id.</dd>
          <dt><strong>No rates show at checkout at all</strong></dt>
          <dd>Either the carrier service is deactivated (Tools → check status / activate), OR the destination is non-GB, OR every carrier is disabled. Check the live <code>/exec</code> URL in a browser to see health stats.</dd>
          <dt><strong>Rate is too high / too low</strong></dt>
          <dd>Run Test calculator with the customer's postcode + cart. The result includes a <code>rule_path</code> string that names every row that fired (e.g. <code>zone:highlands · dpd:standard · surcharges:NI+£15.00</code>). Trace each one back to the row in the relevant tab.</dd>
          <dt><strong>Cart with kettlebells is being routed to the wrong carrier</strong></dt>
          <dd>Per-variant overrides win over product tags. Check the Product carriers tab, expand the kettlebell product and verify each variant's override.</dd>
          <dt><strong>The calculator just timed out</strong></dt>
          <dd>Shopify's budget is 10 seconds. If you're on the first checkout after a long idle window, the Apps Script container may have cold-started. There's a keep-warm trigger running every 5 min. Check <code>/exec</code> health for <code>last_warm_at</code>.</dd>
        </dl>
      </section>

      <section id="shipinfo-cutover" style="margin-bottom:28px;">
        <h3 style="font-size:16px;margin:0 0 8px;">Going live (cutover)</h3>
        <p>Before activating:</p>
        <ol>
          <li><strong>Snapshot</strong> the config (Tools tab) so you have a known-good rollback point.</li>
          <li><strong>Run the coverage test</strong>: exercise every interesting cart shape (light parcel, heavy parcel, pallet weight, each zone, each carrier).</li>
          <li><strong>Activate the carrier service</strong>: only after sign-off. This flips <code>active: true</code> on the registered service and customers start seeing AG Shipping rates immediately.</li>
          <li><strong>Deactivate Pigeon</strong> in Shopify admin (or just disable its rates as a one-toggle rollback path for the first week).</li>
        </ol>
        <p>Rollback: deactivate the AG carrier service (Tools tab), re-enable Pigeon's rates. No data loss either way, both calcs read from independent config.</p>
      </section>
    `;
    /* Smooth scroll for the jump anchors. */
    root.querySelectorAll('a[href^="#shipinfo-"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        e.preventDefault();
        var tgt = document.getElementById(a.getAttribute('href').slice(1));
        if (tgt) tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ─── Tools tab: snapshot + CSV + audit log ───────────────── */
  var TOOLS_TABLES = [
    { sheet: 'Config', label: 'Config' },
    { sheet: 'Shipping_Carriers', label: 'Carriers' },
    { sheet: 'Shipping_Speed_Buckets', label: 'Speed buckets' },
    { sheet: 'Shipping_Carrier_Bucket_Meta', label: 'Carrier × bucket' },
    { sheet: 'Shipping_Rates', label: 'Parcel rates' },
    { sheet: 'Shipping_Carrier_Surcharges', label: 'Surcharges' },
    { sheet: 'Shipping_Pallets', label: 'Pallet rates' },
    { sheet: 'Shipping_Zones', label: 'Zones' },
    { sheet: 'Shipping_FreeShipping', label: 'Free shipping' },
    { sheet: 'Shipping_Sku_Overrides', label: 'SKU overrides' },
    { sheet: 'Shipping_Sku_Variant_Carriers', label: 'Variant overrides' },
    { sheet: 'Shipping_Closed_Days', label: 'Closed days (bank holidays)' }
  ];

  function renderTools(root) {
    var tableOptions = TOOLS_TABLES.map(function(t) {
      return '<option value="' + esc(t.sheet) + '">' + esc(t.label) + '</option>';
    }).join('');
    root.innerHTML = `
      <h2 class="ag-h2">Tools</h2>
      <p class="ag-muted" style="font-size:12px;">Snapshot before a big edit, bulk-edit via CSV, audit who changed what.</p>

      <section style="margin-top:16px;padding:14px;border:1px solid #e6e6e6;border-radius:6px;background:#fafafa;">
        <h3 style="margin:0 0 8px;font-size:14px;">Snapshot config</h3>
        <p class="ag-muted" style="font-size:12px;margin:0 0 10px;">Copies every config tab into a new Google Sheet, useful before activating or before a Pigeon → AG migration. Run_Log is not included.</p>
        <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">
          <input class="ag-input" id="tools-snapshot-note" placeholder="Note (optional, e.g. 'pre-cutover')" style="flex:1;min-width:200px;">
          <button class="ag-btn ag-btn-primary" id="tools-snapshot-go">Snapshot now</button>
        </div>
        <div id="tools-snapshot-result" style="margin-top:10px;font-size:12px;"></div>
      </section>

      <section style="margin-top:14px;padding:14px;border:1px solid #e6e6e6;border-radius:6px;background:#fafafa;">
        <h3 style="margin:0 0 8px;font-size:14px;">Export table → CSV</h3>
        <p class="ag-muted" style="font-size:12px;margin:0 0 10px;">Downloads the current sheet contents as a CSV file. Edit in Excel/Numbers, then re-import below.</p>
        <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">
          <select class="ag-select" id="tools-export-table">${tableOptions}</select>
          <button class="ag-btn ag-btn-primary" id="tools-export-go">Download CSV</button>
        </div>
        <div id="tools-export-result" style="margin-top:10px;font-size:12px;"></div>
      </section>

      <section style="margin-top:14px;padding:14px;border:1px solid #e6e6e6;border-radius:6px;background:#fafafa;">
        <h3 style="margin:0 0 8px;font-size:14px;">Import table ← CSV</h3>
        <p class="ag-muted" style="font-size:12px;margin:0 0 10px;">Header row must exactly match the live table (open Export above to grab the canonical header). Replace mode wipes existing rows first; Append leaves them in place.</p>
        <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:8px;">
          <select class="ag-select" id="tools-import-table">${tableOptions}</select>
          <select class="ag-select" id="tools-import-mode">
            <option value="replace">Replace existing rows</option>
            <option value="append">Append to existing rows</option>
          </select>
          <input type="file" id="tools-import-file" accept=".csv,text/csv" style="font-size:12px;">
        </div>
        <button class="ag-btn ag-btn-primary" id="tools-import-go">Import CSV</button>
        <div id="tools-import-result" style="margin-top:10px;font-size:12px;"></div>
      </section>

      <section style="margin-top:14px;padding:14px;border:1px solid #e6e6e6;border-radius:6px;background:#fafafa;">
        <h3 style="margin:0 0 8px;font-size:14px;">Audit log (last 50 admin actions)</h3>
        <p class="ag-muted" style="font-size:12px;margin:0 0 10px;">Every save / delete / snapshot / import / carrier-service toggle appears here.</p>
        <button class="ag-btn secondary" id="tools-audit-refresh" style="font-size:12px;">Refresh</button>
        <div id="tools-audit-body" style="margin-top:10px;"></div>
      </section>
    `;

    $('tools-snapshot-go').addEventListener('click', function() {
      var btn = $('tools-snapshot-go');
      var note = $('tools-snapshot-note').value;
      btn.disabled = true; btn.textContent = 'Snapshotting…';
      AG_ADMIN.api('ui_snapshot_tables', { note: note }).then(function(r) {
        btn.disabled = false; btn.textContent = 'Snapshot now';
        $('tools-snapshot-result').innerHTML = 'Snapshot created: <a href="' + esc(r.snapshot_url) + '" target="_blank" rel="noopener" style="color:#c8102e;">open in Google Sheets</a> · ' + r.tabs.length + ' tab(s) copied.';
      }).catch(function(e) {
        btn.disabled = false; btn.textContent = 'Snapshot now';
        $('tools-snapshot-result').innerHTML = '<span style="color:#c8102e;">Failed: ' + esc(e.message || e) + '</span>';
      });
    });

    $('tools-export-go').addEventListener('click', function() {
      var sheet = $('tools-export-table').value;
      var btn = $('tools-export-go');
      btn.disabled = true; btn.textContent = 'Exporting…';
      AG_ADMIN.api('ui_export_csv', { sheet: sheet }).then(function(r) {
        btn.disabled = false; btn.textContent = 'Download CSV';
        downloadBlob_(r.csv, r.filename || (sheet + '.csv'));
        $('tools-export-result').innerHTML = 'Downloaded ' + r.rows + ' row(s) from ' + esc(sheet) + '.';
      }).catch(function(e) {
        btn.disabled = false; btn.textContent = 'Download CSV';
        $('tools-export-result').innerHTML = '<span style="color:#c8102e;">Failed: ' + esc(e.message || e) + '</span>';
      });
    });

    $('tools-import-go').addEventListener('click', function() {
      var f = $('tools-import-file').files[0];
      if (!f) { $('tools-import-result').innerHTML = '<span style="color:#c8102e;">Pick a CSV file first.</span>'; return; }
      var sheet = $('tools-import-table').value;
      var mode = $('tools-import-mode').value;
      if (!confirm('Import ' + f.name + ' → ' + sheet + ' (' + mode + ')?\n\nReplace mode WIPES existing rows. Snapshot first if unsure.')) return;
      var btn = $('tools-import-go');
      btn.disabled = true; btn.textContent = 'Importing…';
      var reader = new FileReader();
      reader.onload = function(ev) {
        AG_ADMIN.api('ui_import_csv', { sheet: sheet, csv: ev.target.result, mode: mode }).then(function(r) {
          btn.disabled = false; btn.textContent = 'Import CSV';
          $('tools-import-result').innerHTML = 'Imported ' + r.imported_rows + ' row(s) into ' + esc(sheet) + ' (' + mode + ')' + (r.formula_prefixed_quoted ? ' · ' + r.formula_prefixed_quoted + ' formula-prefixed cell(s) escaped' : '') + '.';
        }).catch(function(e) {
          btn.disabled = false; btn.textContent = 'Import CSV';
          $('tools-import-result').innerHTML = '<span style="color:#c8102e;">Failed: ' + esc(e.message || e) + '</span>';
        });
      };
      reader.readAsText(f);
    });

    function paintAudit() {
      var box = $('tools-audit-body');
      box.innerHTML = '<div class="ag-empty" style="padding:18px;font-size:12px;"><span class="ag-spinner"></span> Loading…</div>';
      AG_ADMIN.api('ui_audit_log_tail', { limit: 50 }).then(function(r) {
        if (!r.rows || !r.rows.length) { box.innerHTML = '<div class="ag-empty" style="padding:18px;font-size:12px;">No admin actions logged yet.</div>'; return; }
        box.innerHTML = '<table class="ag-table" style="font-size:12px;"><thead><tr>' +
          '<th>When</th><th>Action</th><th>Sheet</th><th>Row</th><th>Detail</th>' +
          '</tr></thead><tbody>' +
          r.rows.map(function(row) {
            var detail = row.detail.length > 120 ? row.detail.slice(0, 120) + '…' : row.detail;
            return '<tr>' +
              '<td style="white-space:nowrap;">' + esc(row.timestamp_iso.replace('T', ' ').slice(0, 19)) + '</td>' +
              '<td>' + esc(row.action) + '</td>' +
              '<td>' + esc(row.sheet) + '</td>' +
              '<td class="num">' + esc(row.row) + '</td>' +
              '<td><code style="font-size:11px;">' + esc(detail) + '</code></td>' +
              '</tr>';
          }).join('') + '</tbody></table>';
      }).catch(function(e) {
        box.innerHTML = '<div class="ag-empty" style="padding:18px;color:#c8102e;font-size:12px;">Failed: ' + esc(e.message || e) + '</div>';
      });
    }
    $('tools-audit-refresh').addEventListener('click', paintAudit);
    paintAudit();
  }

  function downloadBlob_(text, filename) {
    var blob = new Blob([text], { type: 'text/csv;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function() { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
  }

  /* ─── Test calculator ─────────────────────────────────────── */
  function renderTest(root) {
    root.innerHTML = `
      <h2 class="ag-h2">Test calculator</h2>
      <p class="ag-muted" style="font-size:12px;">Crafts a synthetic Shopify Carrier Service payload and runs it against the live calc. Result mirrors what a real customer would see at checkout.</p>

      <div class="ag-form-grid" style="grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:8px;margin-bottom:14px;">
        <label><span class="label">Destination postcode</span>
          <input class="ag-input" id="test-postcode" value="${esc(state.testPostcode)}" placeholder="CA11 9DP"></label>
        <label><span class="label">Country</span>
          <input class="ag-input" id="test-country" value="${esc(state.testCountry)}" placeholder="GB"></label>
        <label><span class="label">Requested ship date (optional)</span>
          <input class="ag-input" id="test-ship-date" type="date" value="${esc(state.testRequestedShipDate)}"></label>
      </div>

      <h3 style="margin-top:18px;">Cart items</h3>
      <table class="ag-table" style="font-size:13px;"><thead><tr>
        <th>SKU</th><th class="num">Qty</th><th class="num">Weight (g)</th><th class="num">Price (£)</th><th></th>
      </tr></thead><tbody id="test-items-body"></tbody></table>
      <button class="ag-btn secondary" id="test-add-item" style="margin-top:6px;font-size:12px;">+ Add line</button>

      <div style="margin-top:18px;display:flex;gap:8px;">
        <button class="ag-btn ag-btn-primary" id="test-run">Get quote</button>
        <span class="ag-muted" id="test-status" style="font-size:11px;align-self:center;"></span>
      </div>

      <div id="test-result" style="margin-top:18px;"></div>
    `;
    paintTestItems();
    $('test-postcode').addEventListener('input', function(e) { state.testPostcode = e.target.value; });
    $('test-country').addEventListener('input', function(e) { state.testCountry = e.target.value; });
    $('test-ship-date').addEventListener('change', function(e) { state.testRequestedShipDate = e.target.value; });
    $('test-add-item').addEventListener('click', function() {
      state.testItems.push({ sku: '', quantity: 1, grams: 1000, price_pence: 5000 });
      paintTestItems();
    });
    $('test-run').addEventListener('click', runTestQuote);
  }
  function paintTestItems() {
    var tbody = $('test-items-body');
    if (!tbody) return;
    tbody.innerHTML = state.testItems.map(function(it, i) {
      var skuLabel = it.product_title
        ? `<strong>${esc(it.sku)}</strong><br><span class="ag-muted" style="font-size:11px;">${esc(it.product_title)}${it.variant_title ? ' · ' + esc(it.variant_title) : ''}</span>`
        : (it.sku ? `<strong>${esc(it.sku)}</strong>` : '<span class="ag-muted">no SKU selected</span>');
      return `<tr data-line-i="${i}">
        <td style="vertical-align:middle;">
          <button type="button" class="ag-btn secondary" data-edit-i="${i}" style="font-size:12px;padding:6px 12px;display:inline-block;">
            ${skuLabel || 'Pick product'}
          </button>
        </td>
        <td class="num"><input class="ag-input" data-test-field="quantity" data-i="${i}" type="number" min="1" step="1" value="${it.quantity}" style="width:70px;"></td>
        <td class="num"><input class="ag-input" data-test-field="grams" data-i="${i}" type="number" min="0" step="1" value="${it.grams}" style="width:90px;"></td>
        <td class="num"><input class="ag-input" data-test-field="price_pence" data-i="${i}" type="number" min="0" step="1" value="${it.price_pence}" style="width:90px;"></td>
        <td><button class="ag-btn secondary" data-test-rm="${i}" style="padding:3px 8px;font-size:11px;">×</button></td>
      </tr>`;
    }).join('');
    tbody.querySelectorAll('[data-test-field]').forEach(function(input) {
      input.addEventListener('input', function(e) {
        var i = parseInt(e.target.dataset.i, 10);
        var field = e.target.dataset.testField;
        var v = e.target.value;
        state.testItems[i][field] = (parseFloat(v) || 0);
      });
    });
    tbody.querySelectorAll('[data-test-rm]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        var i = parseInt(e.target.dataset.testRm, 10);
        state.testItems.splice(i, 1);
        if (!state.testItems.length) state.testItems.push({ sku: '', quantity: 1, grams: 1000, price_pence: 5000 });
        paintTestItems();
      });
    });
    console.log('[ag-shipping] paintTestItems: ' + tbody.querySelectorAll('[data-edit-i]').length + ' buttons rendered');
    tbody.querySelectorAll('[data-edit-i]').forEach(function(div) {
      div.addEventListener('click', function(e) {
        console.log('[ag-shipping] SKU click', e.target);
        var i = parseInt(div.dataset.editI, 10);
        openProductPicker(i);
      });
    });
    /* Fallback: event delegation in case per-button binding gets clobbered by a re-render. */
    if (!tbody._delegationBound) {
      tbody._delegationBound = true;
      tbody.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-edit-i]');
        if (!btn) return;
        console.log('[ag-shipping] delegated SKU click', btn);
        openProductPicker(parseInt(btn.dataset.editI, 10));
      });
    }
  }

  /* ─── Product picker overlay ──────────────────────────────────
     Type → debounced search against ag-shipping-script's
     ui_search_products → click → autofills SKU + weight + price. */
  function openProductPicker(lineIdx) {
    var existing = document.getElementById('ag-product-picker');
    if (existing) existing.remove();
    var overlay = document.createElement('div');
    overlay.id = 'ag-product-picker';
    /* Use setProperty with !important so any cascading CSS that sets
       display:none on an overlay child of body can't override us. */
    [
      ['position', 'fixed'], ['top', '0'], ['left', '0'], ['right', '0'], ['bottom', '0'],
      ['width', '100vw'], ['height', '100vh'],
      ['background', 'rgba(0,0,0,0.5)'],
      ['z-index', '2147483647'],
      ['display', 'flex'],
      ['align-items', 'center'], ['justify-content', 'center'],
      ['visibility', 'visible'], ['opacity', '1'], ['pointer-events', 'auto']
    ].forEach(function(p) { overlay.style.setProperty(p[0], p[1], 'important'); });
    overlay.innerHTML = `
      <div style="background:#fff;border-radius:8px;width:600px;max-width:92vw;max-height:80vh;display:flex;flex-direction:column;overflow:hidden;">
        <div style="padding:14px 16px;border-bottom:1px solid #eee;display:flex;justify-content:space-between;align-items:center;">
          <strong>Pick a product</strong>
          <button class="ag-btn secondary" id="picker-close" style="padding:4px 10px;font-size:12px;">×</button>
        </div>
        <div style="padding:12px 16px;border-bottom:1px solid #eee;">
          <input class="ag-input" id="picker-q" placeholder="Search by SKU, product title…" style="width:100%;" autocomplete="off" autofocus>
          <div class="ag-muted" style="font-size:11px;margin-top:6px;">Minimum 2 characters.</div>
        </div>
        <div id="picker-results" style="overflow-y:auto;flex:1;padding:8px 0;">
          <div class="ag-empty" style="padding:24px;">Start typing…</div>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    var input = document.getElementById('picker-q');
    var resultsEl = document.getElementById('picker-results');
    var closeBtn = document.getElementById('picker-close');
    var dismiss = function() { overlay.remove(); };
    closeBtn.addEventListener('click', dismiss);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) dismiss(); });
    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape') { dismiss(); document.removeEventListener('keydown', onEsc); }
    });

    var timer = null;
    input.addEventListener('input', function() {
      var q = input.value.trim();
      if (timer) clearTimeout(timer);
      if (q.length < 2) {
        resultsEl.innerHTML = '<div class="ag-empty" style="padding:24px;">Start typing…</div>';
        return;
      }
      timer = setTimeout(function() {
        resultsEl.innerHTML = '<div class="ag-empty" style="padding:24px;"><span class="ag-spinner"></span> Searching…</div>';
        AG_ADMIN.api('ui_search_products', { q: q }).then(function(r) {
          var variants = r.variants || [];
          if (!variants.length) {
            resultsEl.innerHTML = '<div class="ag-empty" style="padding:24px;">No matches.</div>';
            return;
          }
          resultsEl.innerHTML = variants.map(function(v, i) {
            return `<div class="ag-ship-picker-row" data-pick-i="${i}" style="padding:10px 16px;cursor:pointer;border-bottom:1px solid #f4f4f4;display:flex;justify-content:space-between;align-items:center;">
              <div>
                <div><strong>${esc(v.sku)}</strong></div>
                <div class="ag-muted" style="font-size:11px;">${esc(v.product_title)}${v.variant_title ? ' · ' + esc(v.variant_title) : ''}</div>
              </div>
              <div style="text-align:right;font-size:11px;">
                <div>${(v.grams / 1000).toFixed(2)} kg</div>
                <div class="ag-muted">£${(v.price_pence / 100).toFixed(2)}</div>
              </div>
            </div>`;
          }).join('');
          resultsEl.querySelectorAll('[data-pick-i]').forEach(function(row) {
            row.addEventListener('mouseenter', function() { row.style.background = '#f8f8f8'; });
            row.addEventListener('mouseleave', function() { row.style.background = ''; });
            row.addEventListener('click', function() {
              var idx = parseInt(row.dataset.pickI, 10);
              var v = variants[idx];
              var line = state.testItems[lineIdx];
              line.sku = v.sku;
              line.product_title = v.product_title;
              line.variant_title = v.variant_title;
              line.grams = v.grams;
              line.price_pence = v.price_pence;
              dismiss();
              paintTestItems();
            });
          });
        }).catch(function(e) {
          resultsEl.innerHTML = '<div class="ag-empty" style="padding:24px;color:#c8102e;">Search failed: ' + esc(e.message || e) + '</div>';
        });
      }, 250);
    });
    input.focus();
  }
  function runTestQuote() {
    var btn = $('test-run');
    btn.disabled = true; btn.textContent = 'Quoting…';
    $('test-status').textContent = '';
    AG_ADMIN.api('ui_test_quote', {
      postcode: state.testPostcode,
      country: state.testCountry,
      items: state.testItems,
      requested_ship_date: state.testRequestedShipDate
    }).then(function(r) {
      paintTestResult(r);
    }).catch(function(e) {
      $('test-status').textContent = 'Failed: ' + (e.message || e);
    }).then(function() {
      btn.disabled = false; btn.textContent = 'Get quote';
    });
  }
  function paintTestResult(r) {
    var rates = r.rates || [];
    var el = $('test-result');
    if (!rates.length) {
      el.innerHTML = `<div class="ag-empty">No quote returned · zone: ${esc(r.zone || '')} · path: <code>${esc(r.rule_path || '')}</code></div>`;
      return;
    }
    el.innerHTML = `
      <h3 style="margin:0 0 6px 0;">Quote → ${rates.length} option(s) · zone <code>${esc(r.zone || '')}</code></h3>
      <p class="ag-muted" style="font-size:11px;margin:0 0 12px 0;"><code>${esc(r.rule_path || '')}</code></p>
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:8px;">
        ${rates.map(function(rt) {
          var gbp = (parseFloat(rt.total_price) / 100).toFixed(2);
          return `<div style="border:1px solid var(--ag-border);border-radius:6px;padding:12px;background:var(--ag-panel);">
            <div style="display:flex;justify-content:space-between;align-items:baseline;">
              <strong style="font-size:14px;">${esc(rt.service_name)}</strong>
              <span style="font-size:18px;color:#c8102e;"><strong>£${gbp}</strong></span>
            </div>
            ${rt.min_delivery_date ? `<div class="ag-muted" style="font-size:12px;margin-top:4px;">Delivery ${esc(fmtDate(rt.min_delivery_date))}${rt.max_delivery_date && rt.max_delivery_date !== rt.min_delivery_date ? ' – ' + esc(fmtDate(rt.max_delivery_date)) : ''}</div>` : ''}
            ${rt.description ? `<div class="ag-muted" style="font-size:11px;margin-top:6px;">${esc(rt.description)}</div>` : ''}
            <div class="ag-muted" style="font-size:10px;margin-top:6px;font-family:monospace;">${esc(rt.service_code)}</div>
          </div>`;
        }).join('')}
      </div>
    `;
  }

  /* ─── Generic editable table ──────────────────────────────── */
  function renderTable(root, key, saveAction, deleteAction, title, opts) {
    opts = opts || {};
    var table = (state.payload && state.payload[key]) || { headers: [], rows: [] };
    var headers = table.headers || [];
    var allRows = table.rows || [];
    /* Empty headers usually means the sheet doesn't exist yet, guide
       the operator to run setup() instead of letting them click Add
       and create headerless rows. */
    if (!headers.filter(Boolean).length) {
      root.innerHTML = `
        <h2 class="ag-h2">${esc(title.split('. ')[0])}</h2>
        <div class="ag-empty" style="text-align:left;padding:24px;background:var(--ag-panel);border:1px solid var(--ag-border);border-radius:6px;margin-top:12px;">
          <strong>This tab needs the Apps Script setup() to be run first.</strong>
          <p class="ag-muted" style="font-size:12px;margin:6px 0 0 0;">The underlying sheet (<code>${esc(key)}</code>) doesn't exist in the Shipping spreadsheet yet. Open the ag-shipping-script Apps Script editor, run <code>setup()</code> from <code>10_setup.js</code>, then hard-refresh this page.</p>
        </div>
      `;
      return;
    }

    /* Optional carrier filter, keeps the row list manageable when the
       operator has 4-5 carriers each with their own tier set. The
       filtered list passes into paintTableRows; saves go to the full
       backend store regardless of filter. */
    var carriers = ((state.payload && state.payload.carriers && state.payload.carriers.rows) || [])
      .filter(function(c) { return c.carrier_id; });
    var filterStateKey = opts.filterByCarrier;
    var activeFilter = filterStateKey ? (state[filterStateKey] || 'all') : null;
    var visibleRows = allRows;
    if (filterStateKey && activeFilter !== 'all') {
      visibleRows = allRows.filter(function(r) {
        return String(r.carrier_id || '').toLowerCase() === activeFilter;
      });
    }

    var filterDropdown = '';
    if (filterStateKey && carriers.length) {
      filterDropdown = '<select class="ag-select" id="ship-filter-carrier" style="font-size:12px;padding:4px 8px;">' +
        '<option value="all"' + (activeFilter === 'all' ? ' selected' : '') + '>All carriers (' + allRows.length + ')</option>' +
        carriers.map(function(c) {
          var cid = String(c.carrier_id).toLowerCase();
          var n = allRows.filter(function(r) { return String(r.carrier_id || '').toLowerCase() === cid; }).length;
          return '<option value="' + esc(cid) + '"' + (activeFilter === cid ? ' selected' : '') + '>' + esc(c.label || c.carrier_id) + ' (' + n + ')</option>';
        }).join('') +
        '</select>';
    }

    root.innerHTML = `
      <div style="display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap;">
        <h2 class="ag-h2" style="margin:0;">${esc(title)}</h2>
        <div style="display:flex;gap:8px;align-items:center;">
          ${filterDropdown}
          <button class="ag-btn ag-btn-primary" id="ship-save-all" style="font-size:12px;display:none;">Save all changes (<span id="ship-dirty-count">0</span>)</button>
          <button class="ag-btn ag-btn-primary" id="ship-add-row" style="font-size:12px;">+ Add row</button>
        </div>
      </div>
      <p class="ag-muted" style="font-size:11px;margin:4px 0 12px 0;">Edit cells freely. Use <strong>Save all</strong> above when finished, or click Save on a single row. <code>${esc(key)}</code> · ${visibleRows.length} of ${allRows.length} row(s)${activeFilter && activeFilter !== 'all' ? ' (filtered to ' + esc(activeFilter) + ')' : ''}.</p>
      <table class="ag-table" style="font-size:13px;"><thead><tr>
        ${headers.indexOf('display_order') >= 0 ? '<th style="width:24px;"></th>' : ''}
        ${visibleHeaders(headers, key).map(function(h) { return '<th title="' + esc(h) + '">' + esc(colLabel(h)) + '</th>'; }).join('')}
        <th style="width:150px;"></th>
      </tr></thead><tbody id="ship-table-body"></tbody></table>
    `;
    paintTableRows(visibleRows, headers, saveAction, deleteAction, key);
    $('ship-add-row').addEventListener('click', function() {
      var blank = { _row: 0 };
      /* Boolean cols seeded from both existing-data detection AND the
         known-boolean list, so new rows render checkboxes (not text)
         for enabled/add_vat/weekend_dispatch/etc. */
      var booleanCols = Object.assign({}, KNOWN_BOOLEAN_COLUMNS);
      headers.filter(Boolean).forEach(function(h) {
        for (var i = 0; i < allRows.length; i++) {
          if (typeof allRows[i][h] === 'boolean') { booleanCols[h] = true; break; }
        }
      });
      headers.forEach(function(h) {
        if (!h) return;
        blank[h] = booleanCols[h] ? false : '';
      });
      /* If filtered to a specific carrier, pre-fill carrier_id on the
         new row so the operator doesn't have to type it. */
      if (filterStateKey && activeFilter && activeFilter !== 'all' && headers.indexOf('carrier_id') >= 0) {
        blank.carrier_id = activeFilter;
      }
      /* visibleRows === allRows when no filter active. Push once or
         the operator gets two blank rows for every click. */
      allRows.push(blank);
      if (visibleRows !== allRows) visibleRows.push(blank);
      paintTableRows(visibleRows, headers, saveAction, deleteAction, key);
    });
    var fSel = $('ship-filter-carrier');
    if (fSel) {
      fSel.addEventListener('change', function() {
        state[filterStateKey] = fSel.value;
        renderTab();
      });
    }
  }
  /* Display-name overrides for sheet column headers. Keeps the backend
     machine-readable while the operator sees friendly labels. Anything
     not in this map falls back to the raw column name. */
  var COLUMN_LABELS = {
    carrier_id:                'Carrier',
    speed_bucket_id:           'Speed bucket',
    zone:                      'Zone',
    tier:                      'Label',
    enabled:                   'Enabled',
    is_pallet_carrier:         'Pallet carrier?',
    is_fallback:               'Fallback for untagged?',
    combine_max_kg:            'Combine max (kg)',
    combinable:                'Combinable?',
    ships_anything:            'Universal fallback?',
    weight_min_kg:             'Min weight (kg)',
    weight_max_kg:             'Max kg per SKU',
    rate_gbp:                  '1st parcel (£)',
    subsequent_gbp:            'Each extra (£)',
    fuel_pct:                  'Fuel %',
    other_charges_gbp:         'Other charges (£/parcel)',
    excludes_vat:              'Excludes VAT?',
    min_delivery_days:         'Min days',
    max_delivery_days:         'Max days',
    cutoff_hour:               'Cutoff (24h)',
    weekend_dispatch:          'Ships weekends?',
    available_days_of_week:    'Bookable days (e.g. FRI)',
    bucket_id:                 'Bucket ID',
    display_order:             'Order',

    label:                     'Display name',
    description:               'Description',
    notes:                     'Notes',
    prefix:                    'Postcode prefix',
    applies_to_zone:           'Zone',
    applies_to_prefix:         'Postcode prefix',
    per_parcel_gbp:            'Per parcel (£)',
    per_order_gbp:             'Per order (£)',
    condition_tag:             'Trigger product tag',
    condition_attribute:       'Trigger cart attribute',
    name:                      'Name',
    sku:                       'SKU',
    shipping_fee_flat_gbp:     'Flat fee (£)',
    shipping_extra_per_unit_gbp: 'Extra/unit (£)',
    is_pallet_only:            'Pallet-only?',
    min_order_value_gbp:       'Min order (£)',
    condition_discount:        'Trigger discount code',
    service_name:              'Service name shown at checkout',
    force_free:                'Force free?',
    key:                       'Key',
    value:                     'Value'
  };
  function colLabel(h) { return COLUMN_LABELS[h] || h; }

  /* Per-table column-hide map. Listed columns stay in the sheet so
     existing data isn't disturbed, but the admin UI doesn't show
     them. Calc treats hidden = blank/false where applicable. */
  var HIDDEN_COLUMNS = {
    surcharges: ['weight_min_kg', 'weight_max_kg']
  };
  function isColHidden(ownerKey, h) {
    var list = HIDDEN_COLUMNS[ownerKey];
    return !!(list && list.indexOf(h) >= 0);
  }
  function visibleHeaders(headers, ownerKey) {
    return headers.filter(function(h) { return h && !isColHidden(ownerKey, h); });
  }

  /* Columns that should render as a <select> populated from another
     table. Map: column name → function that returns [{value, label}].
     ownerKey is the table being rendered; we suppress the dropdown
     when the column is THIS table's primary-key field (e.g. carrier_id
     on the Carriers tab is where new carriers are defined, so must be
     free-text not a dropdown of existing carriers). */
  function getLookupOptions(colName, ownerKey) {
    var p = state.payload || {};
    /* Skip dropdown when the column is the editing table's own PK. */
    if (ownerKey === 'carriers' && colName === 'carrier_id') return null;
    if (ownerKey === 'speed_buckets' && colName === 'bucket_id') return null;
    if (colName === 'carrier_id') {
      return ((p.carriers && p.carriers.rows) || [])
        .filter(function(r) { return r.carrier_id; })
        .map(function(r) { return { value: r.carrier_id, label: (r.label || r.carrier_id) + ' (' + r.carrier_id + ')' }; });
    }
    if (colName === 'speed_bucket_id') {
      return ((p.speed_buckets && p.speed_buckets.rows) || [])
        .filter(function(r) { return r.bucket_id; })
        .map(function(r) { return { value: r.bucket_id, label: (r.label || r.bucket_id) + ' (' + r.bucket_id + ')' }; });
    }
    if (colName === 'applies_to_zone') {
      /* Surcharge zone gate, blank means "applies to all zones". */
      return [
        { value: '', label: '(all zones)' },
        { value: 'mainland', label: 'Mainland' },
        { value: 'highlands', label: 'Highlands & Islands' },
        { value: 'northern-ireland', label: 'Northern Ireland' },
        { value: 'isle-of-man', label: 'Isle of Man' },
        { value: 'channel-islands', label: 'Channel Islands' }
      ];
    }
    if (colName === 'zone') {
      /* Required field on Shipping_Rates rows, no blank option. */
      return [
        { value: 'mainland', label: 'Mainland' },
        { value: 'highlands', label: 'Highlands & Islands' },
        { value: 'northern-ireland', label: 'Northern Ireland' },
        { value: 'isle-of-man', label: 'Isle of Man' },
        { value: 'channel-islands', label: 'Channel Islands' }
      ];
    }
    return null;
  }

  /* Columns that are ALWAYS rendered as a checkbox regardless of
     current row data (covers fresh blank rows where data-type detection
     can't see a boolean yet). */
  var KNOWN_BOOLEAN_COLUMNS = {
    enabled: true,
    excludes_vat: true,
    weekend_dispatch: true,
    ships_anything: true,
    is_pallet_carrier: true,
    is_pallet_only: true,
    is_fallback: true,
    force_free: true
  };
  /* Columns rendered as <input type="date">. The browser shows the
     user's locale format (UK = DD/MM/YYYY) and opens a native picker
     on click; the underlying value stays as ISO yyyy-mm-dd. */
  var KNOWN_DATE_COLUMNS = {
    closed_date_start: true,
    closed_date_end: true,
    closed_date_iso: true // legacy / pre-migration shape
  };

  function paintTableRows(rows, headers, saveAction, deleteAction, ownerKey) {
    var tbody = $('ship-table-body');
    if (!tbody) return;
    /* Detect boolean columns from existing data first; merge with the
       known-boolean list so fresh-blank tables still render checkboxes. */
    var booleanCols = Object.assign({}, KNOWN_BOOLEAN_COLUMNS);
    headers.filter(Boolean).forEach(function(h) {
      for (var i = 0; i < rows.length; i++) {
        if (typeof rows[i][h] === 'boolean') { booleanCols[h] = true; break; }
      }
    });
    /* Sort by display_order when the column exists so the operator sees
       the rows in the order they'll be presented to the customer (or
       processed by the calc). New blank rows (no _row) drop to the end
       so they don't shuffle around as the operator types in display_order.
       Saved rows with no display_order set sort by sheet row number. */
    var hasOrder = headers.indexOf('display_order') >= 0;
    if (hasOrder) {
      rows.sort(function(a, b) {
        if (!a._row && b._row) return 1;
        if (a._row && !b._row) return -1;
        var ao = parseFloat(a.display_order);
        var bo = parseFloat(b.display_order);
        if (isNaN(ao) && isNaN(bo)) return (a._row || 0) - (b._row || 0);
        if (isNaN(ao)) return 1;
        if (isNaN(bo)) return -1;
        return ao - bo;
      });
    }
    tbody.innerHTML = rows.map(function(r, rowIdx) {
      var cells = visibleHeaders(headers, ownerKey).map(function(h) {
        var v = r[h];
        var lookupOpts = getLookupOptions(h, ownerKey);
        if (lookupOpts) {
          var cur = String(v == null ? '' : v);
          var hasCurrent = lookupOpts.some(function(o) { return String(o.value) === cur; });
          var options = lookupOpts.map(function(o) {
            return '<option value="' + esc(o.value) + '"' + (String(o.value) === cur ? ' selected' : '') + '>' + esc(o.label) + '</option>';
          }).join('');
          /* If current value isn't in the option list, prepend it as a
             freeform stub so the operator's existing data is visible
             and editable in the dropdown. */
          if (cur && !hasCurrent) {
            /* Existing data references a value that isn't in the
               current options list (likely a deleted carrier/bucket).
               Surface it loudly so the operator fixes the stale row. */
            options = '<option value="' + esc(cur) + '" selected style="color:#c00;">⚠ ' + esc(cur) + ' (not in list, fix or delete this row)</option>' + options;
          } else if (!cur) {
            options = '<option value="">pick one, </option>' + options;
          }
          return '<td><select class="ag-select" data-row-field="' + esc(h) + '" data-row-idx="' + rowIdx + '" style="font-size:12px;padding:4px 6px;">' + options + '</select></td>';
        }
        if (booleanCols[h] || typeof v === 'boolean') {
          var checked = v === true || String(v).toUpperCase() === 'TRUE';
          return '<td><input type="checkbox" data-row-field="' + esc(h) + '" data-row-idx="' + rowIdx + '" ' + (checked ? 'checked' : '') + '></td>';
        }
        if (KNOWN_DATE_COLUMNS[h]) {
          /* Coerce existing value to yyyy-mm-dd in case the backend
             returned something else (e.g. ISO timestamp leaked through). */
          var iso = String(v == null ? '' : v).slice(0, 10);
          return '<td style="width:150px;white-space:nowrap;"><input type="date" class="ag-input" data-row-field="' + esc(h) + '" data-row-idx="' + rowIdx + '" value="' + esc(iso) + '" style="max-width:140px;"></td>';
        }
        return '<td><input class="ag-input" data-row-field="' + esc(h) + '" data-row-idx="' + rowIdx + '" value="' + esc(v == null ? '' : v) + '"></td>';
      }).join('');
      var isNew = !r._row;
      var reorderBtns = '';
      var dragAttr = '';
      var gripCell = '';
      if (hasOrder && !isNew) {
        var atTop = rowIdx === 0 || !rows[rowIdx - 1] || !rows[rowIdx - 1]._row;
        var atBot = rowIdx === rows.length - 1 || !rows[rowIdx + 1] || !rows[rowIdx + 1]._row;
        reorderBtns =
          '<button class="ag-btn secondary" data-reorder="up" data-row-idx="' + rowIdx + '" ' + (atTop ? 'disabled' : '') + ' style="padding:3px 6px;font-size:11px;" title="Move up">↑</button> ' +
          '<button class="ag-btn secondary" data-reorder="down" data-row-idx="' + rowIdx + '" ' + (atBot ? 'disabled' : '') + ' style="padding:3px 6px;font-size:11px;" title="Move down">↓</button> ';
        dragAttr = ' draggable="true" data-drag-row="' + rowIdx + '"';
        gripCell = '<td style="cursor:grab;width:24px;text-align:center;color:#aaa;font-size:14px;user-select:none;" title="Drag to reorder">⋮⋮</td>';
      } else if (hasOrder) {
        /* Spacer so columns line up with reorderable rows. */
        gripCell = '<td style="width:24px;"></td>';
      }
      return '<tr data-row-idx="' + rowIdx + '"' + dragAttr + '>' + gripCell + cells +
        '<td style="white-space:nowrap;">' + reorderBtns +
        '<button class="ag-btn secondary" data-save="' + rowIdx + '" style="padding:3px 8px;font-size:11px;">Save</button>' +
        (!isNew ? ' <button class="ag-btn secondary" data-delete="' + rowIdx + '" style="padding:3px 8px;font-size:11px;color:#c8102e;">×</button>' : '') +
        '</td></tr>';
    }).join('');
    tbody.querySelectorAll('[data-row-field]').forEach(function(input) {
      function handle(e) {
        var idx = parseInt(e.target.dataset.rowIdx, 10);
        var field = e.target.dataset.rowField;
        rows[idx][field] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        if (ownerKey) markDirty(ownerKey, rows[idx], headers, saveAction);
      }
      input.addEventListener('input', handle);
      input.addEventListener('change', handle);
    });
    /* Drag-and-drop reorder, for tables with display_order. Lets the
       operator move a row multiple positions in one drag, beats clicking
       ↑↓ four times to bump something to the top. On drop, the calc
       renumbers display_order (10, 20, 30, …) and saves any row whose
       value changed in one parallel batch. */
    if (hasOrder) {
      var dragSrcIdx = null;
      tbody.querySelectorAll('[data-drag-row]').forEach(function(tr) {
        tr.addEventListener('dragstart', function(e) {
          dragSrcIdx = parseInt(tr.dataset.dragRow, 10);
          e.dataTransfer.effectAllowed = 'move';
          try { e.dataTransfer.setData('text/plain', String(dragSrcIdx)); } catch (_) {}
          tr.style.opacity = '0.4';
        });
        tr.addEventListener('dragend', function() {
          tr.style.opacity = '';
          tbody.querySelectorAll('[data-drag-row]').forEach(function(x) {
            x.style.borderTop = '';
            x.style.borderBottom = '';
          });
        });
        tr.addEventListener('dragover', function(e) {
          e.preventDefault();
          e.dataTransfer.dropEffect = 'move';
          var targetIdx = parseInt(tr.dataset.dragRow, 10);
          if (dragSrcIdx == null || targetIdx === dragSrcIdx) return;
          tbody.querySelectorAll('[data-drag-row]').forEach(function(x) {
            x.style.borderTop = ''; x.style.borderBottom = '';
          });
          /* Drop indicator: above if moving up, below if moving down. */
          if (targetIdx < dragSrcIdx) tr.style.borderTop = '2px solid #c8102e';
          else tr.style.borderBottom = '2px solid #c8102e';
        });
        tr.addEventListener('drop', function(e) {
          e.preventDefault();
          var targetIdx = parseInt(tr.dataset.dragRow, 10);
          if (dragSrcIdx == null || targetIdx === dragSrcIdx) return;
          var srcRow = rows[dragSrcIdx];
          if (!srcRow || !srcRow._row) return;
          /* Splice the source out, insert it at the target's current
             position. Then renumber every saved row 10/20/30 so the
             new sort order matches the operator's drop intent. */
          rows.splice(dragSrcIdx, 1);
          var insertAt = targetIdx > dragSrcIdx ? targetIdx : targetIdx;
          if (targetIdx > dragSrcIdx) insertAt = targetIdx; // post-splice the target shifted left by 1, but insert AFTER it = same idx
          rows.splice(insertAt, 0, srcRow);
          var saved = rows.filter(function(r) { return r._row; });
          var changed = [];
          saved.forEach(function(r, i) {
            var newOrder = (i + 1) * 10;
            if (parseFloat(r.display_order) !== newOrder) {
              r.display_order = newOrder;
              changed.push(r);
            }
          });
          tbody.querySelectorAll('[data-drag-row]').forEach(function(x) { x.style.pointerEvents = 'none'; });
          Promise.all(changed.map(function(r) {
            var payload = { _row: r._row, row: {} };
            headers.filter(Boolean).forEach(function(h) { payload.row[h] = r[h]; });
            return AG_ADMIN.api(saveAction, payload);
          })).then(function() {
            paintTableRows(rows, headers, saveAction, deleteAction, ownerKey);
            AG_ADMIN.api('ui_bootstrap', {}).then(function(p) { state.payload = p; });
          }).catch(function(e) {
            alert('Drag reorder failed: ' + (e.message || e));
            paintTableRows(rows, headers, saveAction, deleteAction, ownerKey);
          });
        });
      });
    }
    tbody.querySelectorAll('[data-reorder]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        var idx = parseInt(btn.dataset.rowIdx, 10);
        var dir = btn.dataset.reorder; // 'up' | 'down'
        var swapIdx = dir === 'up' ? idx - 1 : idx + 1;
        if (swapIdx < 0 || swapIdx >= rows.length) return;
        var a = rows[idx];
        var b = rows[swapIdx];
        if (!a._row || !b._row) return; // never swap with a blank-new row
        /* Swap display_order values. Initialise any blank to (idx*10)+10
           so future arrows are stable. */
        var aOrder = parseFloat(a.display_order);
        var bOrder = parseFloat(b.display_order);
        if (isNaN(aOrder)) aOrder = (idx + 1) * 10;
        if (isNaN(bOrder)) bOrder = (swapIdx + 1) * 10;
        a.display_order = bOrder;
        b.display_order = aOrder;
        var btns = tbody.querySelectorAll('[data-reorder]');
        btns.forEach(function(b2) { b2.disabled = true; });
        function saveRow(r) {
          var payload = { _row: r._row, row: {} };
          headers.filter(Boolean).forEach(function(h) { payload.row[h] = r[h]; });
          return AG_ADMIN.api(saveAction, payload);
        }
        Promise.all([saveRow(a), saveRow(b)]).then(function() {
          paintTableRows(rows, headers, saveAction, deleteAction, ownerKey);
          AG_ADMIN.api('ui_bootstrap', {}).then(function(p) { state.payload = p; });
        }).catch(function(e) {
          /* Revert on error. */
          a.display_order = aOrder;
          b.display_order = bOrder;
          paintTableRows(rows, headers, saveAction, deleteAction, ownerKey);
          alert('Reorder failed: ' + (e.message || e));
        });
      });
    });
    tbody.querySelectorAll('[data-save]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(btn.dataset.save, 10);
        var r = rows[idx];
        btn.disabled = true; btn.textContent = '…';
        var payload = { _row: r._row || 0, row: {} };
        headers.filter(Boolean).forEach(function(h) { payload.row[h] = r[h]; });
        AG_ADMIN.api(saveAction, payload).then(function(resp) {
          if (resp._row) r._row = resp._row;
          if (ownerKey) markClean(ownerKey, r);
          btn.textContent = '✓ Saved';
          setTimeout(function() { btn.disabled = false; btn.textContent = 'Save'; }, 1200);
          // refresh payload so other tabs see the change
          AG_ADMIN.api('ui_bootstrap', {}).then(function(p) { state.payload = p; });
        }).catch(function(e) {
          btn.disabled = false; btn.textContent = 'Save';
          alert('Save failed: ' + (e.message || e));
        });
      });
    });
    /* Save all, saves every dirty row across the whole admin (not just
       this table). Works in parallel with a small concurrency cap so
       Apps Script doesn't choke. */
    var saveAllBtn = document.getElementById('ship-save-all');
    if (saveAllBtn && !saveAllBtn.__bound) {
      saveAllBtn.__bound = true;
      saveAllBtn.addEventListener('click', function() {
        var entries = Object.values(dirty.rows);
        if (!entries.length) return;
        saveAllBtn.disabled = true; saveAllBtn.textContent = 'Saving…';
        var failed = [];
        function saveOne(entry) {
          var payload = { _row: entry.ref._row, row: {} };
          entry.headers.filter(Boolean).forEach(function(h) { payload.row[h] = entry.ref[h]; });
          return AG_ADMIN.api(entry.saveAction, payload).then(function() {
            markClean(entry.sheetKey, entry.ref);
          }).catch(function(e) {
            failed.push({ entry: entry, error: e });
          });
        }
        Promise.all(entries.map(saveOne)).then(function() {
          saveAllBtn.disabled = false;
          refreshDirtyUi();
          if (failed.length) {
            alert(failed.length + ' row(s) failed to save:\n' + failed.map(function(f) { return ' • ' + f.entry.sheetKey + ' row ' + f.entry.ref._row + ': ' + (f.error.message || f.error); }).join('\n'));
          }
          AG_ADMIN.api('ui_bootstrap', {}).then(function(p) { state.payload = p; renderTab(); });
        });
      });
    }
    refreshDirtyUi();
    tbody.querySelectorAll('[data-delete]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(btn.dataset.delete, 10);
        var r = rows[idx];
        if (!r._row) return;
        if (!confirm('Delete this row?')) return;
        btn.disabled = true;
        AG_ADMIN.api(deleteAction, { _row: r._row }).then(function() {
          if (ownerKey) markClean(ownerKey, r);
          rows.splice(idx, 1);
          paintTableRows(rows, headers, saveAction, deleteAction, ownerKey);
        }).catch(function(e) {
          alert('Delete failed: ' + (e.message || e));
          btn.disabled = false;
        });
      });
    });
  }

  /* ─── Config tab (key/value rows) ─────────────────────────── */
  function renderConfig(root) {
    var cfg = state.payload.config || {};
    var cs = state.payload.carrier_service || {};
    var skuSummary = state.payload.sku_carrier_summary || { total_skus: 0, tagged: 0, fallback: 0, last_synced_at: null };
    root.innerHTML = `
      <h2 class="ag-h2">Config</h2>

      <div style="background:var(--ag-panel);border:1px solid var(--ag-border);border-radius:6px;padding:14px;margin:12px 0;">
        <h3 style="margin:0 0 8px 0;">SKU → carrier sync</h3>
        <div style="display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap;">
          <div style="display:flex;gap:16px;font-size:12px;flex-wrap:wrap;">
            <div><strong>${skuSummary.total_skus}</strong> SKUs total</div>
            <div style="color:#2a7a2a;"><strong>${skuSummary.tagged}</strong> tagged <code>carrier:&lt;id&gt;</code></div>
            <div class="ag-muted"><strong>${skuSummary.fallback}</strong> fallback to <code>${esc(cfg.default_carrier_id ? cfg.default_carrier_id.value : 'default')}</code></div>
            ${skuSummary.last_synced_at ? `<div class="ag-muted">last synced ${esc(String(skuSummary.last_synced_at).slice(0, 19))}</div>` : '<div class="ag-muted">never synced</div>'}
          </div>
          <button class="ag-btn secondary" id="ship-sync-skus" style="font-size:12px;">Re-sync now</button>
        </div>
        <p class="ag-muted" style="font-size:11px;margin:8px 0 0 0;">Walks Shopify products, reads <code>carrier:&lt;id&gt;</code> tags, populates Shipping_Sku_Carriers. Auto-runs hourly via installed trigger. Tag products from the inventory dashboard or Shopify admin and re-sync to pick them up immediately.</p>
      </div>

      <div style="background:var(--ag-panel);border:1px solid var(--ag-border);border-radius:6px;padding:14px;margin:12px 0;">
        <h3 style="margin:0 0 8px 0;">Carrier service status</h3>
        ${cs.registered ? `
          <div style="display:flex;justify-content:space-between;align-items:center;">
            <div>
              <div><strong>${esc(cs.name)}</strong> · id <code>${esc(cs.id)}</code></div>
              <div class="ag-muted" style="font-size:11px;margin-top:2px;">${esc(cs.callback_url)}</div>
              <div style="margin-top:6px;">
                <span class="ag-pill ${cs.active ? 'ok' : 'mute'}">${cs.active ? 'ACTIVE, customers see rates' : 'INACTIVE, rates hidden'}</span>
              </div>
            </div>
            <button class="ag-btn ${cs.active ? 'secondary' : 'ag-btn-primary'}" id="cs-toggle">${cs.active ? 'Deactivate' : 'Activate'}</button>
          </div>
        ` : `<div class="ag-empty">Not registered. Run registerCarrierService() in the Apps Script editor.</div>`}
      </div>

      <h3>Key / value config</h3>
      <table class="ag-table" style="font-size:13px;"><thead><tr><th>Key</th><th>Value</th><th>Notes</th><th></th></tr></thead><tbody>
        ${Object.keys(cfg).map(function(k) {
          var row = cfg[k];
          return `<tr><td><code>${esc(k)}</code></td>
            <td><input class="ag-input" data-cfg-key="${esc(k)}" data-cfg-field="value" value="${esc(row.value)}"></td>
            <td><input class="ag-input" data-cfg-key="${esc(k)}" data-cfg-field="notes" value="${esc(row.notes || '')}"></td>
            <td><button class="ag-btn secondary" data-cfg-save="${esc(k)}" style="padding:3px 8px;font-size:11px;">Save</button></td>
          </tr>`;
        }).join('')}
      </tbody></table>
    `;
    var syncBtn = $('ship-sync-skus');
    if (syncBtn) {
      syncBtn.addEventListener('click', function() {
        syncBtn.disabled = true; syncBtn.textContent = 'Syncing…';
        AG_ADMIN.api('ui_sync_sku_carriers', {}).then(function(r) {
          syncBtn.textContent = '✓ ' + (r.tagged || 0) + ' tagged · ' + (r.untagged || 0) + ' fallback (' + (r.duration_ms || 0) + 'ms)';
          setTimeout(function() { refresh(); }, 1200);
        }).catch(function(e) {
          alert('Sync failed: ' + (e.message || e));
          syncBtn.disabled = false; syncBtn.textContent = 'Re-sync now';
        });
      });
    }
    var csBtn = $('cs-toggle');
    if (csBtn) {
      csBtn.addEventListener('click', function() {
        var nextActive = !cs.active;
        if (nextActive && !confirm('Activate? Customers WILL see AG Shipping rates at checkout immediately.')) return;
        csBtn.disabled = true;
        AG_ADMIN.api('ui_set_carrier_service_active', { active: nextActive }).then(function() {
          refresh();
        }).catch(function(e) {
          alert('Failed: ' + (e.message || e));
          csBtn.disabled = false;
        });
      });
    }
    root.querySelectorAll('[data-cfg-key]').forEach(function(input) {
      input.addEventListener('input', function(e) {
        var k = e.target.dataset.cfgKey;
        var field = e.target.dataset.cfgField;
        if (!cfg[k]) cfg[k] = { value: '', notes: '' };
        cfg[k][field] = e.target.value;
      });
    });
    root.querySelectorAll('[data-cfg-save]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var k = btn.dataset.cfgSave;
        var row = cfg[k];
        btn.disabled = true; btn.textContent = '…';
        AG_ADMIN.api('ui_save_config_row', { key: k, value: row.value, notes: row.notes || '' }).then(function() {
          btn.textContent = '✓';
          setTimeout(function() { btn.disabled = false; btn.textContent = 'Save'; }, 1200);
        }).catch(function(e) {
          btn.disabled = false; btn.textContent = 'Save';
          alert('Save failed: ' + (e.message || e));
        });
      });
    });
  }

  /* ─── Product carriers tab ────────────────────────────────────
     Search Shopify products by SKU or title, see their current
     carrier:* tag assignments, toggle multi-carrier checkboxes per
     product, save back via productUpdate. Skips the trip to the
     Shopify admin → product → tags screen. */
  var productCarriersState = {
    query: '',
    results: [],
    edits: {},     // product_id → { carrier_id → bool } pending edit
    selected: {},  // product_id → true (row checkbox state for bulk)
    loaded: false, // tracks whether we've fetched at least once
    hasNextPage: false,
    endCursor: null,
    expanded: {},  // product_id → true (row is showing variants)
    variantData: {} // product_id → { variants[], loading, error }
  };
  function renderProductCarriers(root) {
    var carriers = ((state.payload && state.payload.carriers && state.payload.carriers.rows) || [])
      .filter(function(c) { return c.carrier_id && c.enabled !== false; });
    root.innerHTML = `
      <h2 class="ag-h2">Product carriers</h2>
      <p class="ag-muted" style="font-size:12px;">Assign carriers to products. Saves write back to Shopify product tags as <code>carrier:&lt;id&gt;</code>. ${carriers.length} carrier${carriers.length === 1 ? '' : 's'} available.</p>
      <div style="display:flex;gap:8px;align-items:center;margin:12px 0;flex-wrap:wrap;">
        <input class="ag-input" id="pcar-q" placeholder="Filter by SKU or title (live-search; clear to show all)" value="${esc(productCarriersState.query)}" style="flex:1;max-width:520px;">
        <button class="ag-btn secondary" id="pcar-refresh" style="font-size:12px;">Refresh</button>
        <span class="ag-muted" id="pcar-status" style="font-size:11px;"></span>
      </div>
      <div id="pcar-bulk-bar" style="display:none;background:#fff5f5;border:1px solid #f0bdbd;padding:10px 14px;border-radius:6px;margin-bottom:10px;align-items:center;gap:12px;flex-wrap:wrap;">
        <strong id="pcar-bulk-count" style="font-size:13px;">0 selected</strong>
        <span style="font-size:11px;color:#666;">Apply carriers to all selected (replaces existing assignments):</span>
        <div id="pcar-bulk-carriers" style="display:flex;gap:8px;flex-wrap:wrap;"></div>
        <button class="ag-btn ag-btn-primary" id="pcar-bulk-apply" style="font-size:12px;">Apply to selected</button>
        <button class="ag-btn secondary" id="pcar-bulk-clear" style="font-size:11px;">Clear selection</button>
      </div>
      <div id="pcar-results"><div class="ag-empty" style="padding:24px;"><span class="ag-spinner"></span> Loading products…</div></div>
    `;
    var searchTimer = null;
    $('pcar-q').addEventListener('input', function() {
      if (searchTimer) clearTimeout(searchTimer);
      searchTimer = setTimeout(function() { runProductSearch(carriers); }, 350);
    });
    $('pcar-refresh').addEventListener('click', function() { runProductSearch(carriers); });
    /* Bulk carrier picker. */
    document.getElementById('pcar-bulk-carriers').innerHTML = carriers.map(function(c) {
      var cid = String(c.carrier_id).toLowerCase();
      return '<label style="font-size:12px;display:inline-flex;align-items:center;gap:4px;">' +
        '<input type="checkbox" data-pcar-bulk-cid="' + esc(cid) + '"> ' + esc(c.label || cid) +
        '</label>';
    }).join('');
    $('pcar-bulk-apply').addEventListener('click', function() { runBulkApply(carriers); });
    $('pcar-bulk-clear').addEventListener('click', function() {
      productCarriersState.selected = {};
      paintProductCarrierResults(carriers);
    });
    /* Auto-load on first tab open. */
    if (!productCarriersState.loaded) runProductSearch(carriers);
    else paintProductCarrierResults(carriers);
  }
  function runProductSearch(carriers, append) {
    var q = $('pcar-q').value.trim();
    if (!append) {
      productCarriersState.query = q;
      productCarriersState.endCursor = null;
    }
    var after = append ? productCarriersState.endCursor : null;
    $('pcar-status').textContent = (append ? 'Loading more…' : (q ? 'Searching for ' + q + '…' : 'Loading…'));
    AG_ADMIN.api('ui_search_products_with_carriers', { q: q, after: after }).then(function(r) {
      var fresh = r.products || [];
      if (append) {
        productCarriersState.results = productCarriersState.results.concat(fresh);
      } else {
        productCarriersState.results = fresh;
        productCarriersState.edits = {};
      }
      productCarriersState.loaded = true;
      productCarriersState.hasNextPage = !!r.has_next_page;
      productCarriersState.endCursor = r.end_cursor || null;
      var n = productCarriersState.results.length;
      $('pcar-status').textContent = n + ' product' + (n === 1 ? '' : 's') + (q ? ' matched' : ' loaded') + (productCarriersState.hasNextPage ? ' (more available)' : '');
      paintProductCarrierResults(carriers);
    }).catch(function(e) {
      $('pcar-status').textContent = 'Failed: ' + (e.message || e);
    });
  }
  function selectedProductIds() {
    return Object.keys(productCarriersState.selected).filter(function(id) { return productCarriersState.selected[id]; });
  }
  function refreshBulkBar() {
    var bar = $('pcar-bulk-bar');
    var n = selectedProductIds().length;
    if (!bar) return;
    if (n > 0) {
      bar.style.display = 'flex';
      $('pcar-bulk-count').textContent = n + ' selected';
    } else {
      bar.style.display = 'none';
    }
  }
  function runBulkApply(carriers) {
    var ids = selectedProductIds();
    if (!ids.length) return;
    var checks = document.querySelectorAll('[data-pcar-bulk-cid]');
    var carrierIds = Array.prototype.filter.call(checks, function(c) { return c.checked; })
      .map(function(c) { return c.dataset.pcarBulkCid; });
    if (!confirm('Apply ' + carrierIds.length + ' carrier(s) to ' + ids.length + ' product(s)? This REPLACES existing carrier:* tags on those products.')) return;
    var btn = $('pcar-bulk-apply');
    btn.disabled = true; btn.textContent = 'Applying… (~' + Math.ceil(ids.length * 0.3) + 's)';
    AG_ADMIN.api('ui_bulk_set_product_carriers', {
      product_ids: ids, carrier_ids: carrierIds
    }).then(function(r) {
      alert('Updated ' + (r.updated || 0) + ' product(s)' + (r.failed ? '; ' + r.failed + ' failed' : '') + '.');
      productCarriersState.selected = {};
      runProductSearch(carriers); // refresh to pull new tag state
    }).catch(function(e) {
      alert('Bulk apply failed: ' + (e.message || e));
      btn.disabled = false; btn.textContent = 'Apply to selected';
    });
  }
  function paintProductCarrierResults(carriers) {
    var box = $('pcar-results');
    if (!box) return;
    var rows = productCarriersState.results;
    if (!rows.length) {
      box.innerHTML = '<div class="ag-empty" style="padding:24px;">No products.</div>';
      refreshBulkBar();
      return;
    }
    /* Determine if "select all" should be ticked. */
    var visibleSelectedCount = rows.filter(function(p) { return productCarriersState.selected[p.product_id]; }).length;
    var allSelected = visibleSelectedCount === rows.length;
    box.innerHTML = '<table class="ag-table" style="font-size:13px;"><thead><tr>' +
      '<th style="width:32px;"><input type="checkbox" id="pcar-select-all" ' + (allSelected ? 'checked' : '') + ' title="Select all visible"></th>' +
      '<th>Product</th>' +
      carriers.map(function(c) { return '<th style="text-align:center;font-size:11px;">' + esc(c.label || c.carrier_id) + '<br><code style="font-size:10px;color:#888;">' + esc(c.carrier_id) + '</code></th>'; }).join('') +
      '<th style="text-align:center;font-size:11px;width:90px;" title="Tick to allow this product to share a parcel with other combinable items, up to the carrier\'s combine_max_kg.">Combinable<br><code style="font-size:10px;color:#888;">tag</code></th>' +
      '<th></th></tr></thead><tbody>' +
      rows.map(function(p, rowIdx) {
        var skuLine = (p.variants || []).map(function(v) { return v.sku; }).filter(Boolean).join(', ');
        var pendingEdit = productCarriersState.edits[p.product_id];
        var assigned = pendingEdit || (p.assigned_carriers || []).reduce(function(m, c) { m[c] = true; return m; }, {});
        var changed = !!pendingEdit;
        var isSelected = !!productCarriersState.selected[p.product_id];
        var isExpanded = !!productCarriersState.expanded[p.product_id];
        var variantRowsHtml = '';
        if (isExpanded) {
          var loaded = productCarriersState.variantData[p.product_id];
          if (!loaded || loaded.loading) {
            variantRowsHtml = '<tr><td colspan="' + (carriers.length + 3) + '" class="ag-muted" style="padding:14px 24px;font-size:12px;"><span class="ag-spinner"></span> Loading variants…</td></tr>';
          } else if (loaded.error) {
            variantRowsHtml = '<tr><td colspan="' + (carriers.length + 3) + '" class="ag-empty" style="color:#c00;">Failed to load: ' + esc(loaded.error) + '</td></tr>';
          } else {
            variantRowsHtml = (loaded.variants || []).map(function(v, vi) {
              var override = v.override_carrier_id || '';
              return '<tr style="background:#fafafa;">' +
                '<td></td>' +
                '<td style="padding-left:32px;font-size:12px;">' +
                  '<div style="font-family:monospace;font-weight:600;">' + esc(v.sku || '(no SKU)') + '</div>' +
                  '<div class="ag-muted" style="font-size:11px;">' + esc(v.title || 'Default') + ' · ' + (v.grams ? (v.grams / 1000).toFixed(2) + ' kg' : 'no weight') + '</div>' +
                '</td>' +
                carriers.map(function(c) {
                  var cid = String(c.carrier_id).toLowerCase();
                  /* Radio-style: only one override carrier per variant
                     in v1 (matches the single carrier_id storage). */
                  return '<td style="text-align:center;"><input type="radio" name="pcar-var-' + esc(v.sku) + '" data-pcar-var-row="' + rowIdx + '" data-pcar-var-sku="' + esc(v.sku) + '" data-pcar-var-cid="' + esc(cid) + '" data-pcar-var-pid="' + esc(p.product_id) + '" data-pcar-var-vid="' + esc(v.variant_id) + '" data-pcar-var-vtitle="' + esc(v.title || '') + '" ' + (override === cid ? 'checked' : '') + '></td>';
                }).join('') +
                '<td>' +
                  (override
                    ? '<button class="ag-btn secondary" data-pcar-var-clear="' + esc(v.sku) + '" data-pcar-var-row="' + rowIdx + '" style="padding:2px 8px;font-size:10px;" title="Remove override (fall back to product tag)">× clear</button>'
                    : '<span class="ag-muted" style="font-size:10px;">inherits</span>'
                  ) +
                '</td>' +
              '</tr>';
            }).join('');
          }
        }
        return '<tr data-row="' + rowIdx + '"' + (isSelected ? ' style="background:rgba(200, 16, 46,0.04);"' : '') + '>' +
          '<td><input type="checkbox" class="pcar-row-check" data-pcar-pid="' + esc(p.product_id) + '" ' + (isSelected ? 'checked' : '') + '></td>' +
          '<td><div style="display:flex;align-items:center;gap:6px;">' +
            '<button class="ag-btn secondary" data-pcar-expand="' + rowIdx + '" style="padding:0 6px;font-size:11px;width:24px;height:24px;line-height:1;" title="' + (isExpanded ? 'Collapse' : 'Expand variants') + '">' + (isExpanded ? '▾' : '▸') + '</button>' +
            '<div><div style="font-weight:600;">' + esc(p.title) + '</div>' +
            (skuLine ? '<div class="ag-muted" style="font-size:11px;font-family:monospace;">' + esc(skuLine) + '</div>' : '') +
            '</div></div>' +
          '</td>' +
          carriers.map(function(c) {
            var cid = String(c.carrier_id).toLowerCase();
            return '<td style="text-align:center;"><input type="checkbox" data-pcar-cid="' + esc(cid) + '" data-pcar-row="' + rowIdx + '" ' + (assigned[cid] ? 'checked' : '') + '></td>';
          }).join('') +
          '<td style="text-align:center;"><input type="checkbox" data-pcar-combinable="' + rowIdx + '" ' + (p.combinable ? 'checked' : '') + ' title="Toggle combinable tag"></td>' +
          '<td><button class="ag-btn ' + (changed ? 'ag-btn-primary' : 'secondary') + '" data-pcar-save="' + rowIdx + '" style="padding:3px 10px;font-size:11px;">' + (changed ? 'Save' : 'Saved') + '</button></td>' +
        '</tr>' + variantRowsHtml;
      }).join('') +
      '</tbody></table>' +
      (productCarriersState.hasNextPage
        ? '<div style="margin-top:12px;text-align:center;"><button class="ag-btn ag-btn-primary" id="pcar-load-more" style="font-size:12px;">Load more (' + rows.length + ' loaded)</button></div>'
        : (rows.length >= 50 ? '<p class="ag-muted" style="text-align:center;font-size:11px;margin-top:12px;">End of catalogue · ' + rows.length + ' product(s) loaded.</p>' : ''));
    var loadMore = $('pcar-load-more');
    if (loadMore) loadMore.addEventListener('click', function() { runProductSearch(carriers, true); });
    /* Per-carrier checkbox handlers. */
    box.querySelectorAll('[data-pcar-cid]').forEach(function(cb) {
      cb.addEventListener('change', function() {
        var rowIdx = parseInt(cb.dataset.pcarRow, 10);
        var cid = cb.dataset.pcarCid;
        var product = productCarriersState.results[rowIdx];
        var edit = productCarriersState.edits[product.product_id];
        if (!edit) {
          edit = {};
          (product.assigned_carriers || []).forEach(function(c) { edit[c] = true; });
          productCarriersState.edits[product.product_id] = edit;
        }
        edit[cid] = cb.checked;
        if (!cb.checked) delete edit[cid];
        paintProductCarrierResults(carriers);
      });
    });
    /* Combinable checkbox. Saves immediately (single round-trip, no
       row-save button needed for this flag). Optimistic UI update +
       silent revert on error. */
    box.querySelectorAll('[data-pcar-combinable]').forEach(function(cb) {
      cb.addEventListener('change', function() {
        var rowIdx = parseInt(cb.dataset.pcarCombinable, 10);
        var product = productCarriersState.results[rowIdx];
        var prev = !!product.combinable;
        var next = cb.checked;
        product.combinable = next;
        AG_ADMIN.api('ui_set_product_combinable', {
          product_id: product.product_id, combinable: next
        }).catch(function(e) {
          product.combinable = prev;
          cb.checked = prev;
          alert('Could not update combinable: ' + (e.message || e));
        });
      });
    });
    /* Per-row save. */
    box.querySelectorAll('[data-pcar-save]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var rowIdx = parseInt(btn.dataset.pcarSave, 10);
        var product = productCarriersState.results[rowIdx];
        var edit = productCarriersState.edits[product.product_id];
        if (!edit) return;
        var ids = Object.keys(edit).filter(function(k) { return edit[k]; });
        btn.disabled = true; btn.textContent = '…';
        AG_ADMIN.api('ui_set_product_carriers', {
          product_id: product.product_id, carrier_ids: ids
        }).then(function() {
          product.assigned_carriers = ids;
          delete productCarriersState.edits[product.product_id];
          paintProductCarrierResults(carriers);
        }).catch(function(e) {
          alert('Save failed: ' + (e.message || e));
          btn.disabled = false; btn.textContent = 'Save';
        });
      });
    });
    /* Row select checkboxes. */
    box.querySelectorAll('.pcar-row-check').forEach(function(cb) {
      cb.addEventListener('change', function() {
        var pid = cb.dataset.pcarPid;
        if (cb.checked) productCarriersState.selected[pid] = true;
        else delete productCarriersState.selected[pid];
        paintProductCarrierResults(carriers);
        refreshBulkBar();
      });
    });
    /* Expand / collapse. Fetch variants lazily on first expand. */
    box.querySelectorAll('[data-pcar-expand]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var rowIdx = parseInt(btn.dataset.pcarExpand, 10);
        var product = productCarriersState.results[rowIdx];
        var pid = product.product_id;
        var isOpen = !!productCarriersState.expanded[pid];
        if (isOpen) {
          delete productCarriersState.expanded[pid];
          paintProductCarrierResults(carriers);
          return;
        }
        productCarriersState.expanded[pid] = true;
        if (!productCarriersState.variantData[pid]) {
          productCarriersState.variantData[pid] = { loading: true };
          paintProductCarrierResults(carriers);
          AG_ADMIN.api('ui_get_product_variants', { product_id: pid }).then(function(r) {
            productCarriersState.variantData[pid] = { variants: r.variants || [] };
            paintProductCarrierResults(carriers);
          }).catch(function(e) {
            productCarriersState.variantData[pid] = { error: e.message || String(e) };
            paintProductCarrierResults(carriers);
          });
        } else {
          paintProductCarrierResults(carriers);
        }
      });
    });
    /* Per-variant radio. Picking writes an override row immediately. */
    box.querySelectorAll('[data-pcar-var-cid]').forEach(function(rb) {
      rb.addEventListener('change', function() {
        if (!rb.checked) return;
        var sku = rb.dataset.pcarVarSku;
        var pid = rb.dataset.pcarVarPid;
        var vid = rb.dataset.pcarVarVid;
        var vtitle = rb.dataset.pcarVarVtitle;
        var cid = rb.dataset.pcarVarCid;
        var rowIdx = parseInt(rb.dataset.pcarVarRow, 10);
        var product = productCarriersState.results[rowIdx];
        AG_ADMIN.api('ui_set_variant_carrier', {
          sku: sku, carrier_id: cid,
          product_id: pid, variant_id: vid,
          product_title: product.title, variant_title: vtitle
        }).then(function() {
          /* Patch local cache. */
          var vd = productCarriersState.variantData[pid];
          if (vd && vd.variants) {
            vd.variants.forEach(function(v) {
              if (String(v.sku || '').toUpperCase() === sku.toUpperCase()) v.override_carrier_id = cid;
            });
          }
          paintProductCarrierResults(carriers);
        }).catch(function(e) {
          alert('Variant save failed: ' + (e.message || e));
        });
      });
    });
    box.querySelectorAll('[data-pcar-var-clear]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var sku = btn.dataset.pcarVarClear;
        var rowIdx = parseInt(btn.dataset.pcarVarRow, 10);
        var product = productCarriersState.results[rowIdx];
        var pid = product.product_id;
        AG_ADMIN.api('ui_set_variant_carrier', { sku: sku, carrier_id: '' }).then(function() {
          var vd = productCarriersState.variantData[pid];
          if (vd && vd.variants) {
            vd.variants.forEach(function(v) {
              if (String(v.sku || '').toUpperCase() === sku.toUpperCase()) v.override_carrier_id = '';
            });
          }
          paintProductCarrierResults(carriers);
        }).catch(function(e) {
          alert('Clear failed: ' + (e.message || e));
        });
      });
    });
    /* Select-all. */
    var selAll = $('pcar-select-all');
    if (selAll) {
      selAll.addEventListener('change', function() {
        rows.forEach(function(p) {
          if (selAll.checked) productCarriersState.selected[p.product_id] = true;
          else delete productCarriersState.selected[p.product_id];
        });
        paintProductCarrierResults(carriers);
        refreshBulkBar();
      });
    }
    refreshBulkBar();
  }

  /* ─── Logs tab ────────────────────────────────────────────── */
  function renderLogs(root) {
    root.innerHTML = `
      <div style="display:flex;justify-content:space-between;align-items:center;">
        <h2 class="ag-h2" style="margin:0;">Recent quote requests</h2>
        <button class="ag-btn secondary" id="logs-refresh">Refresh</button>
      </div>
      <p class="ag-muted" style="font-size:11px;">Every Shopify Carrier Service callback writes a row here. Useful for debugging "why was this customer quoted £X".</p>
      <div id="logs-body"><div class="ag-empty"><span class="ag-spinner"></span> Loading…</div></div>
    `;
    $('logs-refresh').addEventListener('click', loadLogs);
    loadLogs();
  }
  function loadLogs() {
    AG_ADMIN.api('ui_recent_logs', { limit: 100 }).then(function(r) {
      var rows = r.rows || [];
      $('logs-body').innerHTML = rows.length ? `
        <table class="ag-table" style="font-size:12px;"><thead><tr>
          <th>Time</th><th>Zone</th><th>Postcode</th><th class="num">Weight</th><th class="num">Subtotal</th><th class="num">Quoted</th><th>Service</th><th>Rule path</th><th>Notes</th>
        </tr></thead><tbody>${rows.map(function(r) {
          return `<tr>
            <td class="ag-muted">${esc(String(r.logged_at).slice(0, 19))}</td>
            <td>${esc(r.resolved_zone || '')}</td>
            <td>${esc(r.shop_postcode || '')}</td>
            <td class="num">${(r.total_weight_kg || 0).toFixed ? r.total_weight_kg.toFixed(2) : r.total_weight_kg} kg</td>
            <td class="num">£${(parseFloat(r.subtotal_gbp) || 0).toFixed(2)}</td>
            <td class="num"><strong>${fmtMoney(r.quoted_gbp)}</strong></td>
            <td>${esc(r.quoted_service_name || '')}</td>
            <td class="ag-muted" style="font-family:monospace;font-size:10px;">${esc(r.rule_path || '')}</td>
            <td class="ag-muted">${esc(r.notes || '')}</td>
          </tr>`;
        }).join('')}</tbody></table>
      ` : '<div class="ag-empty">No quote requests logged yet. Test the calculator or place a draft order.</div>';
    }).catch(function(e) {
      $('logs-body').innerHTML = '<div class="ag-empty">Failed: ' + esc(e.message || e) + '</div>';
    });
  }
})();
